import canBeInsertedInto from './can-be-inserted-into';
import isBlockOnPage from './is-block-on-page';
import isElementBlock from './is-element-block';
import isGlobalBlock from './is-global-block';
import isReloadRequired from './is-reload-required';
import isBlockDisabled from './is-block-disabled';

export default {
  canBeInsertedInto,
  isBlockOnPage,
  isElementBlock,
  isReloadRequiredAfterInsert: isReloadRequired,
  isGlobalBlock,
  isBlockDisabled,
};
